import * as React from 'react';
const SvgIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M140-190v-580l688.46 290zm60-90 474-200-474-200v147.69L416.92-480 200-427.69zm0 0v-400z"></path>
  </svg>;
export default React.memo(SvgIcon);